import * as dialog from '../components/dialog';
import {callbackOnElements, hasURLParameter} from '@borngroup/born-utilities';

/**
 * Very simple script to open a modal when clicking on an element with the "data-modal-trigger" attribute.
 * The "data-modal-trigger" attribute contains all settings dialog.js and born-modal support.
 */
export default class ModalTrigger {
    constructor(options) {
        callbackOnElements(options.elements, this.setupTriggers.bind(this));
    }

    setupTriggers(currentTrigger) {
        let triggerData = JSON.parse(currentTrigger.getAttribute('data-modal-trigger'));

        triggerData.options = triggerData.options || {};

        if (triggerData.options.auto) {
            if (typeof triggerData.options.auto === 'string' && hasURLParameter(triggerData.options.auto)) {
                this.triggerHandler(currentTrigger, triggerData);
            } else if (!isNaN(triggerData.options.auto)) {
                window.setTimeout(this.triggerHandler.bind(this, currentTrigger, triggerData), triggerData.options.auto);
            } else {
                this.triggerHandler(currentTrigger, triggerData);
            }
        }

        triggerData.options.afterCloseFocusEl = currentTrigger;

        currentTrigger.addEventListener('click', this.triggerHandler.bind(this, currentTrigger, triggerData));

        //Prevents redirection done through the tracking implementaion.
        currentTrigger.setAttribute('data-disable-redirect', '');

        //Avoid re-attaching listeners.
        currentTrigger.removeAttribute('data-modal-trigger');
    }

    triggerHandler(currentTrigger, triggerData, evt) {
        if (evt) {
            evt.preventDefault();
        }

        //If the `dynamicURL` flag is set, attempt to get the URL from the currentTrigger itself.
        if (triggerData.dynamicURL) {
            triggerData.url = currentTrigger.href || currentTrigger.getAttribute('data-url') || currentTrigger.value || triggerData.url;
        }

        dialog.open(triggerData);
    }
}
